import ErrorDisplay from '~components/layout/error/error-display/error-display'
import { PageTitleAndTracking } from '~components/page-title-and-tracking'

export default function Unauthorized() {
  return (
    <>
      <PageTitleAndTracking title="InSite | 404" />
      <ErrorDisplay
        heading="Sorry, we couldn't find this page"
        text="You might not have permission to see this page"
        isPageError
      />
    </>
  )
}
